module.exports = __webpack_public_path__ + "static/media/PM.fdf5ab61.jpg";